import { useDecodedToken } from './authorization.hook';

/** Returns true when one X4C user is impersonating a resellerId.
 *  Used currently only for X4A integration.
 */
export function useIsImpersonationMode() {
  const decodedToken = useDecodedToken();

  if (
    !decodedToken ||
    !decodedToken?.imoProfile ||
    typeof decodedToken.imoProfile.impersonationMode !== 'boolean'
  ) {
    return false;
  }

  return decodedToken.imoProfile.impersonationMode;
}
